// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"24583a82","455":"661796a2","977":"17ffb79f"}[chunkId] + ".chunk.js";
};